
define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var FacebookConfigModel = {};

    var KEYS = {
        PAGE_ID: "pageId",
        ACCESS_TOKEN: "accessToken"
    };

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        FacebookConfigModel = RevisionedModel.extend({
            KEYS: KEYS,
            name: "FacebookConfigModel",
            defaults: {
                pageId: "",
                access_token: ""
            },

            validation:{
                "pageId":[
                    {
                        required: true,
                        minLength: 1
                    }
                ],
                "access_token":[
                    {
                        required: true,
                        minLength: 1
                    }
                ]
            },

            initialize: function(attrs, options) {
                this.typeConfiguration = options.typeConfiguration;
            },

            getTypeConfiguration: function() {
                return this.typeConfiguration;
            },

            getPageId: function () {
                return this.get(KEYS.PAGE_ID);
            },

            setPageId: function (pageId) {
                this.set(KEYS.PAGE_ID, pageId);
            },

            getAccessToken: function(){
                return this.get(KEYS.ACCESS_TOKEN);
            },

            setAccessToken: function(accessToken){
                this.set(KEYS.ACCESS_TOKEN, accessToken);
            },

            isConfigStepComplete: function(){
                return !_.isEmpty(this.getPageId()) && !_.isEmpty(this.getAccessToken());
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    FacebookConfigModel.KEYS = KEYS;

    return FacebookConfigModel;
});

